import { Box } from '#/components/Box/Box';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { LegacyPrimaryButton } from '#/components/LegacyButton/LegacyPrimaryButton';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import type { CmsApiLogosBlockData } from '#/modules/cms/api/types/blocks/CmsApiLogosBlock';
import { trackAnchorClicked } from '#/utils/analytics/track/trackAnchorClicked';

import {
  LogoImageContainer,
  LogoImageGroupContainer,
  LogosButtonContainer,
} from './CmsLogosBlock.styled';

type Props = {
  data: CmsApiLogosBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsLogosBlock({ data, blockIndex, pageUpdated }: Props) {
  const { headline, sections, buttonText, buttonUrl } = data;

  return (
    <Box qaId={`logos-${blockIndex}`}>
      {headline && (
        <RichTextHeadline textAlignCenter>{headline}</RichTextHeadline>
      )}
      {
        // TODO: Fix this from eslint v9 update
        // oxlint-disable-next-line react/jsx-key
        sections.map((section) => (
          <LogoImageGroupContainer>
            <LogoImageContainer>
              <FilestackImage
                alt={section.imageOne.altText}
                data={section.imageOne}
                qaId={`image-${section.imageOne.altText}`}
                height={94}
              />
            </LogoImageContainer>
            <LogoImageContainer>
              <FilestackImage
                alt={section.imageTwo.altText}
                data={section.imageTwo}
                qaId={`image-${section.imageTwo.altText}`}
                height={94}
              />
            </LogoImageContainer>
            <LogoImageContainer>
              <FilestackImage
                alt={section.imageThree.altText}
                data={section.imageThree}
                qaId={`image-${section.imageThree.altText}`}
                height={94}
              />
            </LogoImageContainer>
          </LogoImageGroupContainer>
        ))
      }

      {buttonText && buttonUrl && (
        <LogosButtonContainer>
          <LegacyPrimaryButton
            component={StyledNativeLinkWithRef}
            href={buttonUrl}
            mt={24}
            onClick={(event) =>
              trackAnchorClicked(event, 'CMS Block', {
                block_position: blockIndex,
                block_type: 'Logos',
                cta_type: 'Button',
                page_updated: pageUpdated,
              })
            }
          >
            {buttonText}
          </LegacyPrimaryButton>
        </LogosButtonContainer>
      )}
    </Box>
  );
}
